"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkPosition = checkPosition;
exports.getZonesByCountry = exports.getZoneSubZones = exports.getZoneBySubZoneName = exports.getZone = exports.getZipcode = exports.getSubZoneByZipcode = exports.getServedSubZonesFromBlockedZipcodes = exports.getDeliveryFees = exports.getCountryFromZone = void 0;
exports.isInZone = isInZone;
exports.zones = void 0;
var _countries = _interopRequireWildcard(require("../countries"));
var _country = require("../country");
var _utils = require("./utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var zonesWithoutZipCodes = [].concat(_toConsumableArray(_country.atZones), _toConsumableArray(_country.beZones), _toConsumableArray(_country.bgZones), _toConsumableArray(_country.chZones), _toConsumableArray(_country.cyZones), _toConsumableArray(_country.czZones), _toConsumableArray(_country.deZones), _toConsumableArray(_country.dkZones), _toConsumableArray(_country.eeZones), _toConsumableArray(_country.esZones), _toConsumableArray(_country.fiZones), _toConsumableArray(_country.frZones), _toConsumableArray(_country.gbZones), _toConsumableArray(_country.grZones), _toConsumableArray(_country.hrZones), _toConsumableArray(_country.huZones), _toConsumableArray(_country.ieZones), _toConsumableArray(_country.itZones), _toConsumableArray(_country.liZones), _toConsumableArray(_country.ltZones), _toConsumableArray(_country.luZones), _toConsumableArray(_country.lvZones), _toConsumableArray(_country.mtZones), _toConsumableArray(_country.nlZones), _toConsumableArray(_country.noZones), _toConsumableArray(_country.plZones), _toConsumableArray(_country.ptZones), _toConsumableArray(_country.roZones), _toConsumableArray(_country.seZones), _toConsumableArray(_country.siZones), _toConsumableArray(_country.skZones));
var zones = exports.zones = zonesWithoutZipCodes.map(function (zone) {
  return _objectSpread(_objectSpread({}, zone), {}, {
    zipcodes: zone.subZones.reduce(function (result, subZone) {
      return _objectSpread(_objectSpread({}, result), subZone.zipcodes);
    }, {})
  });
});
var getSubZoneByZipcode = exports.getSubZoneByZipcode = function getSubZoneByZipcode(zipcode) {
  var countryCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _countries.DEFAULT_COUNTRY;
  var country = (0, _countries["default"])(function (str) {
    return str;
  }).find(function (countryRegistered) {
    return countryRegistered.id === countryCode;
  });
  return zones.filter(function (zone) {
    return countryCode === zone.country;
  }).flatMap(function (zone) {
    return zone.subZones;
  }).find(function (subZone) {
    return Object.keys(subZone.zipcodes).find(function (subZoneZipcode) {
      return country === null || country === void 0 ? void 0 : country.zipcodeMatcher(zipcode, subZoneZipcode);
    });
  });
};
var getZoneBySubZoneName = exports.getZoneBySubZoneName = function getZoneBySubZoneName(subZoneName) {
  var countryCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _countries.DEFAULT_COUNTRY;
  return zones.filter(function (zone) {
    return countryCode === zone.country;
  }).find(function (zone) {
    return zone.subZones.some(function (subZone) {
      return subZone.name === subZoneName || (0, _utils.getNewSubZoneName)(subZoneName) === subZone.name;
    });
  });
};
var getZone = exports.getZone = function getZone(zipcode) {
  var countryCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _countries.DEFAULT_COUNTRY;
  var subZone = getSubZoneByZipcode(zipcode, countryCode);
  return subZone ? getZoneBySubZoneName(subZone === null || subZone === void 0 ? void 0 : subZone.name, countryCode) : undefined;
};
var getZoneSubZones = exports.getZoneSubZones = function getZoneSubZones(zoneId) {
  var _zones$find;
  return (_zones$find = zones.find(function (zone) {
    return zone.id === zoneId;
  })) === null || _zones$find === void 0 ? void 0 : _zones$find.subZones;
};
var getZipcode = exports.getZipcode = function getZipcode(zipcode) {
  var _Object$entries$find;
  var countryCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _countries.DEFAULT_COUNTRY;
  var country = (0, _countries["default"])(function (str) {
    return str;
  }).find(function (countryRegistered) {
    return countryRegistered.id === countryCode;
  });
  var subZone = getSubZoneByZipcode(zipcode, countryCode);
  if (!subZone) return undefined;
  return (_Object$entries$find = Object.entries(subZone.zipcodes).find(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      subZoneZipcode = _ref2[0];
    return country === null || country === void 0 ? void 0 : country.zipcodeMatcher(zipcode, subZoneZipcode);
  })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1];
};
var getDeliveryFees = exports.getDeliveryFees = function getDeliveryFees(zipcode) {
  var _getZipcode, _getZone;
  var countryCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _countries.DEFAULT_COUNTRY;
  var zipcodeDeliveryFee = (_getZipcode = getZipcode(zipcode, countryCode)) === null || _getZipcode === void 0 ? void 0 : _getZipcode.deliveryFee;
  if (typeof zipcodeDeliveryFee === 'number') {
    return zipcodeDeliveryFee;
  }
  return (_getZone = getZone(zipcode, countryCode)) === null || _getZone === void 0 ? void 0 : _getZone.deliveryFee;
};
var getZonesByCountry = exports.getZonesByCountry = function getZonesByCountry() {
  var countryCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _countries.DEFAULT_COUNTRY;
  return zones.filter(function (zone) {
    return zone.country === countryCode;
  });
};
function isInZone(_ref3, zone) {
  var latitude = _ref3.latitude,
    longitude = _ref3.longitude;
  var cornerNW = zone.cornerNW,
    cornerSE = zone.cornerSE;
  return cornerNW.latitude >= latitude && latitude >= cornerSE.latitude && cornerNW.longitude <= longitude && longitude <= cornerSE.longitude;
}
function checkPosition(_ref4) {
  var latitude = _ref4.latitude,
    longitude = _ref4.longitude;
  var zonesToCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : zones;
  return zonesToCheck.reduce(function (response, zone) {
    return response || isInZone({
      latitude: latitude,
      longitude: longitude
    }, zone);
  }, false);
}

/**
 * Returns a list of served subzones from a list of blocked zipcodes
 * @param zoneId - Zone id to filter subzones
 * @param blockedZipcodes - List of zipcodes that are blocked
 * @returns List of subzones that have at least one non-blocked zipcode
 */
var getServedSubZonesFromBlockedZipcodes = exports.getServedSubZonesFromBlockedZipcodes = function getServedSubZonesFromBlockedZipcodes(zoneId, blockedZipcodes) {
  var zone = zones.find(function (z) {
    return z.id === zoneId;
  });
  if (!zone) {
    return [];
  }
  var allSubZones = zone.subZones;
  if (!allSubZones) {
    return [];
  }
  return allSubZones.filter(function (subZone) {
    var subZoneZipcodes = Object.keys(subZone.zipcodes);
    return subZoneZipcodes.some(function (subZoneZipcode) {
      return !blockedZipcodes.includes(subZoneZipcode);
    });
  });
};

/**
 * Returns the country code for a given zone ID
 * @param zoneId - Zone id to get the country for
 * @returns Country code for the zone, or undefined if zone not found
 */
var getCountryFromZone = exports.getCountryFromZone = function getCountryFromZone(zoneId) {
  var zone = zones.find(function (z) {
    return z.id === zoneId;
  });
  return zone === null || zone === void 0 ? void 0 : zone.country;
};